import {useEffect, useState} from 'react';

import {useDispatch} from 'react-redux';
import {useSearchParams} from 'react-router-dom';

import {fetchOrganizationSettingForExternal} from 'Store/OrganizationSettingStore';
import {setFontFaceSrc, updateFontFamily} from 'Store/ThemeStore';
import {FontFamilyList, loadCustomFont} from 'Utils';

const sanitizeFontFamily = (value) => value?.replace(/[^a-zA-Z0-9\s,'"_-]/g, '');

const useFontStyle = (user) => {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const embedWidgetParams = searchParams.get('embedStyle') || '';

  let embedWidgetStyle = {};
  try {
    embedWidgetStyle = JSON.parse(embedWidgetParams);
  } catch (error) {}

  const embedFontFamily = sanitizeFontFamily(embedWidgetStyle.fontFamily);
  const [fontFamily, setFontFamily] = useState('');

  const isCustomFont = !!fontFamily &&
    !FontFamilyList.map((font) => font.toLowerCase()).includes(fontFamily.toLowerCase());

  useEffect(() => {
    if (!embedFontFamily || !user) {
      return;
    }
    if (!isCustomFont) {
      setFontFamily(embedFontFamily);
      return;
    }
    (async () => {
      try {
        const settings = await dispatch(fetchOrganizationSettingForExternal(user)).unwrap();
        const {fontList} = settings;
        const font = fontList.find((f) => f.name === embedFontFamily);
        if (!font) {
          return;
        }
        const {address, name} = font;
        const loadSuccess = await loadCustomFont(address, name);
        if (loadSuccess) {
          setFontFamily(name);
          dispatch(setFontFaceSrc({fontName: name, fontSrc: loadSuccess.fontName}));
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [isCustomFont, user, embedFontFamily, dispatch]);

  useEffect(() => {
    if (fontFamily) {
      dispatch(updateFontFamily(fontFamily));
    }
  }, [fontFamily, dispatch]);

  return {fontFamily};
};

export default useFontStyle;
